import moment from 'moment';
import 'moment/locale/id';

moment.locale('id');

export const formatUnixTimeStamp = (
  timestamp: number,
  customFormat?: string
) => {
  return moment.unix(timestamp).format(customFormat || 'LLL');
};

export const formatTime = (
  date: string | number,
  customFormat?: string,
  locale?: string
) => {
  if (locale) {
    const localeMoment = moment(date);
    localeMoment.locale(locale);
    return localeMoment.format(customFormat || 'LLL');
  }
  return moment(date).format(customFormat || 'LLL');
};

export const formatToUnix = (date: string | number) => {
  return moment(date).unix();
};

export const getTimeDifference = (
  comparedTime: string | number,
  currentTime: number
) => {
  const compared = moment(comparedTime).format('DD/MM/YYYY HH:mm:ss');
  const current = moment(currentTime).format('DD/MM/YYYY HH:mm:ss');
  const diff = moment(compared, 'DD/MM/YYYY HH:mm:ss').diff(
    moment(current, 'DD/MM/YYYY HH:mm:ss')
  );
  return diff;
};

export const beginWithZero = (number: number) => {
  return String(number).padStart(2, '0');
};

export const getRemainingTimeFromTimeDifference = (diff: number) => {
  const duration = moment.duration(diff);
  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  const timeString = `${beginWithZero(hours)}:${beginWithZero(
    minutes
  )}:${beginWithZero(seconds)}`;

  if (days > 0) {
    return `${beginWithZero(days)}:${timeString}`;
  }
  return timeString;
};

/**
 * hourIn24 -> moment().format('k')
 * @param {string} hourIn24 1 2 ... 23 24
 */
export const formatGreeting: (hourIn24: string) => string = hourIn24 => {
  const toInt = parseInt(hourIn24, 10);
  let result = '';
  if (toInt === 24 || toInt <= 11) {
    result = 'Pagi';
  } else if (toInt <= 12 || toInt <= 14) {
    result = 'Siang';
  } else if (toInt <= 15 || toInt <= 17) {
    result = 'Sore';
  } else {
    result = 'Malam';
  }
  return result;
};
